function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F487E",
  d: "M.37 14.4c0-1.1.9-2 2.01-2h70.5a2 2 0 012.02 2v46H.37v-46z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6BAAFF",
  d: "M5.17 18.49c0-1.1.9-2 2.02-2h61.26a2 2 0 012 2V54.1a2 2 0 01-2 2H7.19a2 2 0 01-2.02-2V18.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M14.65 16.8h-4.24L5.5 21.7v4.24l9.15-9.15zM5.5 27.35v4.25l14.8-14.8h-4.24L5.5 27.34zm2-10.55H9l-3.5 3.48V18.8c0-1.1.9-2 2-2zm18.47 0h-4.24L5.5 33v4.24L25.97 16.8zM5.5 38.67v4.24L31.63 16.8H27.4L5.49 38.67zM37.3 16.8h-4.25L5.5 44.32v4.24l31.8-31.78zM5.5 49.98v4.04a2 2 0 000 .2l37.45-37.43h-4.24L5.5 50zM48.61 16.8h-4.24L5.9 55.22a2 2 0 001.59.79h1.87L48.6 16.79zM10.78 56.02h4.25l39.24-39.23h-4.24L10.78 56.02zM70.2 17.85a2 2 0 00-1.77-1.06h-1.42L27.76 56.02h4.25L70.2 17.84zM33.42 56.02h4.25l32.77-32.75v-4.25l-37.02 37zM61.35 16.8h4.24L26.35 56.01H22.1l39.25-39.23zm-1.42 0H55.7L16.44 56.01h4.25l39.24-39.23zm-16.6 39.22h-4.25l31.36-31.34v4.24l-27.11 27.1zm1.41 0H49l21.45-21.44v-4.24l-25.7 25.68zm9.91 0H50.4l20.04-20.03v4.25L54.64 56zm1.41 0h4.25l10.13-10.13v-4.24L56.06 56.02zm9.91 0h-4.25l8.72-8.71v4.24l-4.47 4.47zm1.41 0h1.05a2 2 0 002-2v-1.06l-3.05 3.05z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_1610_55002)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.83 44.45c0 1.7 1.29 1.83 3.22 1.83h25.92c.98 0 1.51-.14 2.18-.77l1.64-1.28 6.43-5.19c.57-.56.89-1.3.89-2.05l-.13-33.05c0-1.7-1.57-3.07-3.5-3.07H21.33c-1.94 0-3.5 1.38-3.5 3.08v40.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#595A5B",
  d: "M50.79 44.23l.16.2-.16-.2zm-3.82 2.05v-.25.25zm2.18-.77l-.18-.18h.01l.01-.02.16.2zm8.96-8.52h-.25.25zm-.89 2.05l.18.18-.01.01h-.01l-.16-.19zM21.32.87v.25-.25zm33.16 0V.62v.25zm3.5 3.07h.25-.25zM21.05 46.28v.25-.25zm27.1-6.32h-.26.25zm6.33-38.84H21.33v-.5h33.15v.5zm-36.4 2.83v40.5h-.5V3.95h.5zM57.86 37l-.13-33.05h.5L58.36 37h-.5zm-36.81 9.04h25.92v.5H21.05v-.5zm27.94-.72l1.65-1.28.3.4-1.64 1.28-.3-.4zm1.64-1.28l6.43-5.18.32.39-6.43 5.18-.32-.39zm-3.66 2c.48 0 .83-.04 1.13-.14.3-.1.56-.26.87-.56l.35.36a2.8 2.8 0 01-1.07.68c-.37.12-.78.16-1.28.16v-.5zM58.36 37c0 .83-.35 1.62-.96 2.23l-.35-.35c.52-.53.8-1.2.8-1.88h.5zM21.33 1.12c-1.83 0-3.25 1.3-3.25 2.83h-.5c0-1.87 1.7-3.33 3.75-3.33v.5zm33.15-.5c2.03 0 3.74 1.46 3.75 3.32h-.5c0-1.53-1.43-2.82-3.25-2.82v-.5zm-36.4 43.83c0 .4.07.67.2.87.11.2.29.35.53.45.51.22 1.26.26 2.24.26v.5c-.96 0-1.82-.03-2.44-.3a1.61 1.61 0 01-.77-.65c-.18-.3-.26-.68-.26-1.13h.5zm29.81 1.62v-6.11h.5v6.1h-.5zm2.14-8.16h7.82v.5h-7.82v-.5zm-2.14 2.05c0-1.11.9-2.05 2.14-2.05v.5c-.97 0-1.64.72-1.64 1.55h-.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M25.62 13.58h16.6m-16.6 13.08h14.44"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M42.22 26.66h8.16m-6.02-13.08h5.92m-24.85 6.94h6.34"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M33.5 20.52h12.2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M47.54 20.52h2.97"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0E4F0",
  d: "M.63 60.3a1 1 0 011-.99h72a1 1 0 011 1v6.52a2 2 0 01-2 2h-70a2 2 0 01-2-2v-6.52z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#595A5B",
  fillRule: "evenodd",
  d: "M74.63 59.31h-.5v7.52c0 .83-.67 1.5-1.5 1.5h-70a1.5 1.5 0 01-1.5-1.5v-7.52h-.5v7.52c0 1.1.9 2 2 2h70a2 2 0 002-2v-7.52z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0E4F0",
  d: "M24.52 68.51h26.21v5.38h-26.2v-5.38z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeWidth: 0.5,
  d: "M.63 66.83v-6.52a1 1 0 011-1h72a1 1 0 011 1v6.52m-74 0c0 1.1.9 2 2 2h70a2 2 0 002-2m-74 0v-7.52h.5v7.52c0 .83.67 1.5 1.5 1.5h70c.83 0 1.5-.67 1.5-1.5v-7.52h.5v7.52m-57.3 7.4h39.93M24.52 68.5h26.21v5.38h-26.2V68.5z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#595A5B",
  d: "M34.08 63.1h7.1v1.72h-7.1z"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1610_55002",
  width: 48.78,
  height: 53.904,
  x: 13.577,
  y: 0.624,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1610_55002"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1610_55002",
  result: "shape"
})));

function SvgMonitorWithDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorWithDocument);
export default __webpack_public_path__ + "static/media/monitor-with-document.9916d3b1.svg";
export { ForwardRef as ReactComponent };